import { render, staticRenderFns } from "./SubjectTemplateItem.vue?vue&type=template&id=74436d0f&scoped=true"
import script from "./SubjectTemplateItem.vue?vue&type=script&lang=js"
export * from "./SubjectTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./SubjectTemplateItem.vue?vue&type=style&index=0&id=74436d0f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74436d0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74436d0f')) {
      api.createRecord('74436d0f', component.options)
    } else {
      api.reload('74436d0f', component.options)
    }
    module.hot.accept("./SubjectTemplateItem.vue?vue&type=template&id=74436d0f&scoped=true", function () {
      api.rerender('74436d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/preSubjectHistory/SubjectTemplateItem.vue"
export default component.exports